import { logoutTypeSchema, type LogoutType } from '@/models/api/logout-type'
import { ssoUrlDataSchema, type SsoUrlData } from '@/models/api/sso-url-data'
import {
  apiValidator,
  type ApiFactory,
  type ApiRequestConfig,
  type ApiResponse
} from '~library/services'

export default class LoginAuthApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 取得FFP_SSO網址
   * https://hackmd.io/3vlC8cxJR4CQFKhl-xcAqA
   */
  @apiValidator(ssoUrlDataSchema)
  getFFPSingleSingOnUrl(url: string): Promise<ApiResponse<SsoUrlData>> {
    return this.api.post('Login/GetFFPSingleSingOnUrl', { url })
  }

  /**
   * API 會員登出
   * https://hackmd.io/jPkrT-0NTni6qGaeF388DA
   */
  @apiValidator(logoutTypeSchema.nullable())
  logout(config?: ApiRequestConfig): Promise<ApiResponse<LogoutType | null>> {
    return this.api.post('Login/Logout', config)
  }
}
